import { FC, PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'

import {
  FixedButtonContainer,
  StickyButtonContainer,
} from 'postQuote/components/StickyButtonContainer'

interface PageWrapperProps extends PropsWithChildren {
  maxWidth?: string
  mb?: string
  pr?: string
  pl?: string
  pb?: string
  mobile?: string
  stickyContent?: ReactNode
  fixedContent?: ReactNode
  className?: string
}

export const PageWrapper: FC<PageWrapperProps> = ({
  maxWidth = '1280px',
  mb = '0px',
  pr = '30px',
  pl = '30px',
  pb = '0px',
  mobile = '16px',
  stickyContent,
  fixedContent,
  children,
  className,
}) => (
  <>
    <Page
      className={className}
      $maxWidth={maxWidth}
      $mb={mb}
      $pr={pr}
      $pb={pb}
      $pl={pl}
      $mobile={mobile}
      data-testid="page-wrapper"
    >
      {children}
    </Page>
    {stickyContent && <StickyButtonContainer>{stickyContent}</StickyButtonContainer>}
    {fixedContent && <FixedButtonContainer>{fixedContent}</FixedButtonContainer>}
  </>
)

interface IPage {
  $maxWidth: string
  $mobile: string
  $mb: string
  $pr: string
  $pl: string
  $pb: string
}

const Page = styled.div<IPage>`
  position: relative;
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth};
  margin-bottom: ${({ $mb }) => $mb};
  padding-bottom: ${({ $pb }) => $pb};
  margin-right: auto;
  margin-left: auto;
  padding-right: ${({ $mobile }) => $mobile};
  padding-left: ${({ $mobile }) => $mobile};

  @media (min-width: 768px) {
    padding-right: ${({ $pr }) => $pr};
    padding-left: ${({ $pl }) => $pl};
  }
`
